<template>
  <report-list />
</template>

<script>
import NgineDashboardIndexReportList from "./NgineDashboardIndexReportList";
// import ReportModal from "./ReportModal";

// @ is an alias to /src
export default {
  name: "ReportIndex",
  components: {
    "report-list": NgineDashboardIndexReportList
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  watch: {}
};
</script>
